import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-barra-progresso',
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule,
    TranslocoModule
  ],
  templateUrl: './barra-progresso.component.html',
  styleUrl: './barra-progresso.component.css'
})
export class BarraProgressoComponent implements OnInit {

  @Input() metaTotal!: number;
  @Input() metaReal!: number;
  @Input() metaIdeal!: number;
  @Input() titulo?: string;
  @Input() corBarra: string = '#C4E7FE';
  @Input() corReal: string = '#1e88e5';
  @Input() corIdeal: string = '#76C6FF';

  public porcBarraReal!: number;
  public porcBarraIdeal!: number;
  public exibirDisplayReal: boolean = true;
  public exibirDisplayIdeal: boolean = true;

  ngOnInit(): void {
    this.calcularPorcentagens();
    this.gerenciaVisibilidadeDisplay();
  }

  public calcularPorcentagens(): void {
    this.porcBarraReal = (this.metaReal / this.metaTotal) * 100;
    this.porcBarraReal = this.porcBarraReal > 100 ? 100 : this.porcBarraReal;

    this.porcBarraIdeal = (this.metaIdeal / this.metaTotal) * 100;
    this.porcBarraIdeal = this.porcBarraIdeal > 100 ? 100 : this.porcBarraIdeal;
  }

  public gerenciaVisibilidadeDisplay(): void {
    this.exibirDisplayReal = this.titulo ? this.porcBarraReal > 6.5 : true;

    const diferenca = this.porcBarraIdeal - this.porcBarraReal;
    this.exibirDisplayIdeal = diferenca > 10;
  }

  public calcularTransform(porc: number): string {
    if (porc <= 5) return 'translateX(0%)';
    if (porc >= 95) return 'translateX(-100%)';
    return 'translateX(-50%)';
  }
}
